import {SupportProduct} from "./SupportProduct";

export class CreateSupportRequest {
    supportCode: string;
    orderNumber: string;
    plannedSlot: Date;
    collectionSlot: Date;
    storeId: string;
    driveId: string;
    deliveryType: string;
    zoneCode: string;
    products: SupportProduct[];
}
